import React from 'react';

const DropperIcon = (props) => (
  <svg {...props} viewBox='0 0 19 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M3.78193 18H0.756387C0.338853 18 0 17.6611 0 17.2436V14.2181C0 14.0168 0.0801989 13.8247 0.220839 13.6825L13.0842 0.819167C14.1748 -0.273056 16.0795 -0.273056 17.1702 0.819167C18.3048 1.95375 18.3048 3.78732 17.1793 4.91429L4.31596 17.7776C4.17532 17.9198 3.98317 18 3.78193 18ZM1.51277 16.4872H3.46875L16.1095 3.84649C16.6451 3.30941 16.6451 2.43654 16.1095 1.89946C15.5724 1.35953 14.6739 1.36865 14.1535 1.89051L1.51277 14.5313V16.4872Z'
      fill={props.fill}
    />
    <path
      d='M15.1282 9.67991C14.9345 9.67991 14.7409 9.60579 14.5926 9.45907L8.54153 3.40798C8.24657 3.11302 8.24657 2.63335 8.54153 2.3384C8.83649 2.04345 9.31616 2.04345 9.6111 2.3384L15.6622 8.3895C15.9572 8.68445 15.9572 9.16412 15.6622 9.45907C15.5155 9.60579 15.3218 9.67991 15.1282 9.67991Z'
      fill={props.fill}
    />
    <path
      d='M6.80748 14.9747H0.756387C0.338853 14.9747 0 14.6358 0 14.2183C0 13.8008 0.338853 13.4619 0.756387 13.4619H6.80748C7.22502 13.4619 7.56387 13.8008 7.56387 14.2183C7.56387 14.6358 7.22502 14.9747 6.80748 14.9747Z'
      fill={props.fill}
    />
  </svg>
);

export default DropperIcon;
